import script from "./MediaSetView.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaSetView.vue?vue&type=script&setup=true&lang=js"

import "./MediaSetView.vue?vue&type=style&index=0&id=72ca4435&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ca4435"]])

export default __exports__